import type { CSSProperties } from 'react';
import { appShellColors } from '../styles/appShell';

interface BrandLogoProps {
  showWordmark?: boolean;
  markSize?: number;
  textColor?: string;
  markColor?: string;
  markTextColor?: string;
  accentColor?: string;
  className?: string;
  style?: CSSProperties;
}

export function BrandLogo({
  showWordmark = true,
  markSize = 36,
  textColor = appShellColors.textPrimary,
  markColor = appShellColors.primary,
  markTextColor = appShellColors.onPrimary,
  accentColor = '#60a5fa',
  className,
  style,
}: BrandLogoProps) {
  return (
    <span className={className} style={style}>
      <svg
        width={markSize}
        height={markSize}
        viewBox="0 0 40 40"
        role={showWordmark ? 'img' : undefined}
        aria-label={showWordmark ? 'VibeUI' : undefined}
        aria-hidden={showWordmark ? undefined : 'true'}
        focusable="false"
      >
        <rect x="3" y="3" width="34" height="34" rx="10" fill={markColor} />
        <rect x="10.5" y="10" width="8.5" height="8.5" rx="2.2" fill={markTextColor} />
        <rect x="21" y="10" width="8.5" height="8.5" rx="2.2" fill={markTextColor} opacity="0.58" />
        <rect x="10.5" y="21" width="8.5" height="8.5" rx="2.2" fill={markTextColor} opacity="0.34" />
        <rect x="21" y="21" width="8.5" height="8.5" rx="2.2" fill={accentColor} />
        <path
          d="M23.3 25.2h3.9M25.25 23.25v3.9"
          fill="none"
          stroke={markColor}
          strokeWidth="1.55"
          strokeLinecap="round"
        />
      </svg>
      {showWordmark && (
        <span className="whitespace-nowrap text-base font-semibold tracking-normal" style={{ color: textColor }}>
          VibeUI
        </span>
      )}
    </span>
  );
}
